import React, { memo } from 'react';
import NavbarListItem from 'modules/common/Navbar/NavbarListItems/NavbarListItem';
import NavbarListItemButton from 'modules/common/Navbar/NavbarListItems/NavbarListItemButton';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { generatePathnameWithLangCode, getPath } from 'utils/RouteHelper';
import { Translator } from 'Translator';
import { BUY_A_GIFT_VOUCHER_LINK } from '~/constants';

const CSS = require('./DefaultNavbarLinks.less');

interface DefaultNavbarLinksProps {
  transparent: boolean;
  isMobile: boolean;
}

function DefaultNavbarLinks({ transparent, location, isMobile }: DefaultNavbarLinksProps & RouteComponentProps) {
  const searchParams = new URLSearchParams(location.search);
  searchParams.set('returnTo', getPath());

  return (
    <ul className={CSS.Links} data-test-id="LoggedOutNavbar">
      <NavbarListItem
        to={BUY_A_GIFT_VOUCHER_LINK}
        transparent={transparent}
        className={CSS.BecomeAHostLink}
        externalLink={true}
      >
        Buy a gift voucher
      </NavbarListItem>
      {!isMobile && <>
        <NavbarListItem
          isLangCurr={true}
          transparent={transparent}
        />
        <NavbarListItem
          data-test-id={'Login'}
          to={{
            pathname: generatePathnameWithLangCode(`/login/`, Translator.getLanguageCode()),
            state: { modal: true, returnPath: location.pathname, returnQuery: location.search },
            search: searchParams.toString()
          }}
          transparent={transparent}
        >
          {Translator.translate('Forms.Buttons.Login', {}, true, 'Log in')}
        </NavbarListItem>
        <NavbarListItemButton
          text={Translator.translate('Forms.Buttons.signUp', {}, true, 'Sign up')}
          to={{
            pathname: generatePathnameWithLangCode(`/signup/`, Translator.getLanguageCode()),
            state: { modal: true, returnPath: location.pathname, returnQuery: location.search },
            search: searchParams.toString()
          }}
          transparent={transparent}
        />
      </>
      }
    </ul>
  );
}

export default withRouter(memo(DefaultNavbarLinks));
